import { render, staticRenderFns } from "./PegaseDetail.vue?vue&type=template&id=0b7725b6&"
import script from "./PegaseDetail.vue?vue&type=script&lang=js&"
export * from "./PegaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports